module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"open":"열림","closed":"닫힘","user_grade":"회원 등급","author_grade":"작성자 등급"}}')
  delete Component.options._Ctor
}
